var module = angular.module('octopusApp.projects');

module.controller('ProjectReleasePackageListController', function ($scope, $uibModalInstance, $q, busy, octopusRepository, currentPackage, channelFilters) {
  var isLoading = $scope.isLoading = busy.create();
  var feed;
  $scope.packageResults = [];
  $scope.package = currentPackage;
  $scope.preRelease = true;
  $scope.channelRules = true;
  $scope.notes = false;

  $scope.refresh = function () {
    var displayPackages = [];
    var displayPromise = getDisplayPackages();

    isLoading.promise(displayPromise);

    loadChannelMatchPackages();

    function getDisplayPackages() {
      return getPackages($scope.channelRules ? channelFilters : {}).then(function(result) {
        displayPackages = result;
        $scope.packageResults = displayPackages;
      });
    }

    function loadChannelMatchPackages() {
      if($scope.channelRules) {
        return;
      }
      $q.all([getPackages(channelFilters), displayPromise])
        .then(function(result) {
          var channelFilteredPackages = result[0];
          var matchIndex = channelFilteredPackages ? _.indexBy(channelFilteredPackages, 'Id') : {};
          displayPackages.forEach(function(pack) {
            pack.IsNonChannelRule = !$scope.channelRules && !matchIndex[pack.Id];
          });
        });
    }
  };

  function getPackages(filter) {
    var searchOptions = _.extend({
      packageId: currentPackage.PackageId,
      partialMatch: false,
      includeMultipleVersions: true,
      includePreRelease: $scope.preRelease,
      includeNotes: $scope.notes,
      take: 1000
    }, filter || {});
    return octopusRepository.Feeds.search(feed, searchOptions);
  }

  $scope.close = function() {
    $uibModalInstance.close();
  };

  $scope.selectVersion = function (version) {
    $uibModalInstance.close(version);
  };

  isLoading.promise(octopusRepository.Feeds.get(currentPackage.FeedId).then(function (f) {
    feed = f;
    $scope.refresh();
  }));

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/controllers/project_release_package_list_controller.js
// module id = 3310562263020291
// module chunks = 1